/** Studio photo: current 3D frame inside a Baobab frame -> native share (iPhone) or PNG download. */
export async function snapshot(src, { name = "Bao", view, pose, version }) {
  if (!src) return;
  const W = 1600, H = 2000, c = document.createElement("canvas");
  c.width = W; c.height = H;
  const g = c.getContext("2d");
  g.fillStyle = "#F6F1E7"; g.fillRect(0, 0, W, H);
  g.fillStyle = "#0A2540"; g.fillRect(0, 0, W, 170); g.fillRect(0, H - 150, W, 150);
  g.fillStyle = "#17A2A2"; g.fillRect(0, 170, W, 8); g.fillRect(0, H - 158, W, 8);
  const pad = 70, bw = W - pad * 2, bh = H - 170 - 158 - pad * 2, sx = src.width * 0.22, sw = src.width * 0.56, r = Math.min(bw / sw, bh / src.height);
  const dw = sw * r, dh = src.height * r;
  g.save(); g.beginPath(); g.roundRect(pad, 178 + pad, bw, bh, 48); g.clip();
  g.fillStyle = "#EEF3F1"; g.fillRect(pad, 178 + pad, bw, bh);
  g.drawImage(src, sx, 0, sw, src.height, pad + (bw - dw) / 2, 178 + pad + (bh - dh) / 2, dw, dh); g.restore();
  g.fillStyle = "#FFFFFF"; g.font = "600 68px Fraunces, Georgia, serif"; g.fillText(name, 70, 112);
  g.fillStyle = "#9FE7DE"; g.font = "700 30px Manrope, sans-serif"; g.textAlign = "right"; g.fillText(`${view} · ${pose}`, W - 70, 104); g.textAlign = "left";
  g.fillStyle = "#E0B33A"; g.font = "800 30px Manrope, sans-serif"; g.fillText("BAOBAB ADVENTURES · MOVE. EXPLORE. RECOVER.", 70, H - 80);
  g.fillStyle = "#D7F5F1"; g.font = "600 24px Manrope, sans-serif"; g.textAlign = "right"; g.fillText(`Modèle 3D réel · ${version || ""}`, W - 70, H - 80);
  return shareCanvas(c, `${name.toLowerCase().replace(/\W+/g, "-")}-studio.png`, `${name} · Baobab Adventures`);
}

/** Native share sheet (iPhone) with PNG download fallback. */
export async function shareCanvas(c, filename, title) {
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], title }); return; } catch (e) { if (e.name === "AbortError") return; }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
